export const liveBaseStoreFields = [
  'FULL'
];
